import React, { ChangeEvent, useEffect, useState } from "react";
import * as _ from "lodash-es";
import { useIntl } from "react-intl";

type Props = {
    options?: any[];
    filterOptionsFn?: (selectedValue: any) => any[];
    valueProp: string;
    showBlankFirst?: boolean;
    selectedOption?: any;
    selectedOptionProp?: string;
    titleProp: string;
    titlePropTwo?: string;
    titleRenderFn?: (option: any) => string;
    fn: ((e: ChangeEvent<HTMLSelectElement>) => void) | ((e: any) => void);
    name: string;
    isRequired?: boolean;
    isDisabled?: boolean;
    isActive?: boolean;
    isDisabledOnActive?: boolean;
    autoSelectSingleOption?: boolean;
    hasSelectedOptionProp?: boolean;
    emitObject?: boolean;
    emitOnLoad?: boolean;
    emitTarget?: boolean;
    title?: string;
    nullIfBlank?: boolean; // not working?
    translateTitle?: boolean;
    className?: string;
    id?: string;
};

export const OwSelectOptionFn = (props: Props) => {
    const intl = useIntl();

    const setSelectedValueFn = (onlyReturnValue?: boolean) => {
        // console.log(`CDM - ${props.name}`);
        let _selectedValue: any = null;
        let isNumberValue = false;

        const propSelectedOption = props.selectedOption;
        let propSelectedOptionProp: any = _.get(props, "selectedOptionProp", "id");

        if (props.hasSelectedOptionProp === false) {
            propSelectedOptionProp = null;
        }

        _.each(props.options, (option, index) => {
            const value = _.get(option, `${props.valueProp}`, "");

            if (_.isNumber(value)) {
                isNumberValue = true;
            }

            // console.log("selectedOption", propSelectedOption);

            if (!_.isNil(propSelectedOption)) {
                if (props.emitObject) {
                    _selectedValue = props.selectedOption;
                } else {
                    if (!_.isNil(propSelectedOptionProp) && propSelectedOptionProp.length > 0) {
                        _selectedValue = propSelectedOption[propSelectedOptionProp];
                    } else {
                        _selectedValue = propSelectedOption;
                    }
                }

                // console.log(
                //     "selectedValue",
                //     selectedValue,
                //     "selectedOption: ",
                //     propSelectedOption,
                //     "selectedOptionProp: ",
                //     propSelectedOptionProp
                // );

                // This prevents us from dealing with the selectedValue being a string, but the provided option
                // values are numbers.
                if (isNumberValue && !_.isNumber(_selectedValue) && !_.isObject(_selectedValue)) {
                    _selectedValue = parseInt(_selectedValue);
                }

                // console.log("Value: ", value, "Selected Value: ", selectedValue, "selectedOption: ", propSelectedOption);
            } else {
                /* istanbul ignore else*/
                if (props.autoSelectSingleOption) {
                    /* istanbul ignore next*/
                    if (props.options && props.options.length === 1) {
                        // selectedValue = value; // auto selecting the first value...don't
                    }
                }
            }
        });

        if (onlyReturnValue) {
            return _selectedValue;
        } else {
            setSelectedValue(_selectedValue);

            if (!props.isActive) {
                if (props.emitOnLoad && !performedInitEmits) {
                    // console.log("emitOnLoad", props.name, selectedValue);
                    if (props.emitObject && !props.emitTarget) {
                        props.fn(props.selectedOption);
                    } else {
                        if (!props.emitTarget) {
                            props.fn(selectedValue);
                        } else {
                            props.fn({ target: { name: props.name, value: selectedValue } } as any);
                        }
                    }

                    setPerformedInitEmits(true);
                } else if (props.autoSelectSingleOption && !performedInitEmits) {
                    setPerformedInitEmits(true);
                }
            }
        }
    };

    const getOptions = (_selectedValue: any) => {
        let availableOptions = props.options;

        if (props.filterOptionsFn) {
            availableOptions = props.filterOptionsFn(_selectedValue);
        }

        const options = (availableOptions || []).map((option, index) => {
            let isNumberValue = false;

            const value = _.get(option, `${props.valueProp}`, "");
            let title = _.get(option, `${props.titleProp}`, "");

            if (props.translateTitle && title) {
                title = intl.formatMessage({ id: title });
            }

            if (_.isNumber(value)) {
                isNumberValue = true;
            }

            // console.log('selectedOption', props.selectedOption);

            if (!_.isNil(_selectedValue)) {
                if (!_.isNil(props.selectedOptionProp) && _.isObject(selectedValue)) {
                    // @ts-expect-error
                    _selectedValue = _selectedValue[props.selectedOptionProp];
                }

                // This prevents us from dealing with the selectedValue being a string, but the provided option
                // values are numbers.
                if (isNumberValue && !_.isNumber(_selectedValue) && !_.isNil(_selectedValue)) {
                    _selectedValue = parseInt(_selectedValue);
                }

                // console.log("Value: ", value, "Selected Value: ", selectedValue);
            } else {
                /* istanbul ignore else*/
                if (!props.isActive) {
                    if (props.autoSelectSingleOption) {
                        /* istanbul ignore next */
                        if (props.options && props.options.length === 1) {
                            /* istanbul ignore next*/

                            if (!performedInitEmits && value) {
                                _selectedValue = value; // auto selecting the first value, dont
                                fn({ target: { name: title, value } } as any);
                            }
                        }
                    }
                }
            }

            let title_two = "";

            if (!_.isNil(props.titlePropTwo)) {
                title_two = " " + _.get(option, `${props.titlePropTwo}`, "");
            }

            let keyIndex = index;

            // in the event that there's a first blank option
            // in order not to mess up the key values for the options
            // we must account for the first being blank.
            if (props.showBlankFirst) {
                keyIndex += 1;
            }

            let titleSet = title + title_two;

            if (props.titleRenderFn) {
                titleSet = props.titleRenderFn(option);
            }

            return (
                <option key={keyIndex} value={value}>
                    {titleSet}
                </option>
            );
        });

        let blankOption;

        if (showBlankFirst) {
            blankOption = <option key={-1} value={""} />;
            options.unshift(blankOption);
        }

        return options;
    };

    const [hasLoaded, setHasLoaded] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState<any>(setSelectedValueFn(true));
    const [showBlankFirst, setShowBlankFirst] = React.useState(!_.isNil(props.showBlankFirst) ? props.showBlankFirst : true);
    const [options, setOptions] = useState(getOptions(selectedValue));
    const [optionsLength, setOptionsLength] = React.useState(props.options?.length || 0);
    const [performedInitEmits, setPerformedInitEmits] = React.useState(false);
    const [invalidClass, setInvalidClass] = useState("");

    useEffect(() => {
        if (hasLoaded) {
            setSelectedValueFn();
        }
    }, [props.selectedOption]);

    useEffect(() => {
        let _invalidClass = "";

        if (props.isRequired) {
            _invalidClass = "is-invalid alert-danger";

            if (selectedValue) {
                _invalidClass = "";
            }
        }

        setInvalidClass(_invalidClass);
    }, [selectedValue]);

    const fn = (e: ChangeEvent<HTMLSelectElement>) => {
        /* istanbul ignore else*/
        if (!_.isNil(e.target) && !_.isNil(e.target.value)) {
            let emitVal = e;

            if (props.emitObject && props.options) {
                for (const option of props.options) {
                    let value: any = e.target.value;

                    /* istanbul ignore else*/
                    if (_.isNumber(option[props.valueProp])) {
                        value = Number(value);
                    }

                    if (option[props.valueProp] === value) {
                        emitVal = option;
                    }
                }
            }

            if (props.nullIfBlank) {
                if (!e.target.value.length) {
                    if (props.emitObject) {
                        // @ts-expect-error
                        emitVal = null;
                        // @ts-expect-error
                        e = null;
                    } else {
                        // @ts-expect-error
                        e.target.value = null;
                    }
                }
            }

            props.fn(emitVal);
        }

        setSelectedValue(e ? e.target.value : e);
    };

    const onMouseDown = (e: any) => {
        e.stopPropagation();
    };

    const handleClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // if (_.isNaN(selectedValue)) {
    //     setSelectedValue("");
    // }

    return (
        <span className={"OwSelectOptionFn"}>
            <select
                id={props.id}
                title={props.title}
                disabled={props.isDisabled || (props.isDisabledOnActive && props.isActive)}
                required={props.isRequired}
                value={selectedValue}
                className={(props.className || "") + " form-select form-select-sm " + invalidClass}
                onChange={(e: any) => {
                    fn(e);
                }}
                onClick={handleClick}
                onMouseDown={onMouseDown}
                name={props.name}
                data-testid={props.name}>
                {options}
            </select>
            {props.isActive ? <i className={"far fa-sync fa-spin"} /> : null}
        </span>
    );
};
